import { render } from "./AdminRolesComponent.vue?vue&type=template&id=1aedde98"
import script from "./AdminRolesComponent.vue?vue&type=script&lang=js"
export * from "./AdminRolesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__